export const MyAccountPageTemplate = {
    slots: ['SlbUserPreferenceSlot']
}